import { CNUser } from './cnuser';

export class CNInsurance extends CNUser {

    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.SNUser.CNUser.CNInsurance';
    }

    get code(): string {
        return this.getProperty('code');
    }

    public clone(): any {
        return new CNInsurance();
    }
}
